
import {
    defineComponent, PropType, ref, Ref
} from 'vue';
import initStep from './init-step';
import initPay from './init-pay';
import {
    UserType, SubscriptionType
} from './all.type';
import ChooseType from './module/choose-type/choose-type.vue';
import PurchaseDetail from './module/purchase-detail/index.vue';
import Information from './module/Information/information.vue';
import Processing from './module/pay/processing.vue';
import PaySuccess from './module/pay/pay-success.vue';
import PayFailed from './module/pay/pay-failed.vue';

export default defineComponent({
    components: {
        ChooseType,
        PurchaseDetail,
        Information,
        Processing,
        PaySuccess,
        PayFailed
    },
    props: {
        // TODO dis角色操作需要记录操作的projectId 批量待定修改
        projectId: {
            type: String,
            default: ''
        },
        userType: {
            required: true,
            type: String as PropType<UserType>
        },
        // 是否是批量操作
        isBatch: {
            type: Boolean,
            default: false
        }
    },
    setup(props) {
        const {
            activeStep,
            setActiveStep,
            backStep
        } = initStep();

        const subscriptionType: Ref<SubscriptionType> = ref('active');

        // 选择操作类型进入下一步
        const setType = (type: SubscriptionType) => {
            subscriptionType.value = type;
            // TODO 先按方法设置，考虑到后期回退可能需要操作，如果后期没有就删除该方法赋值操作
            setActiveStep(1);
        };

        const {
            setInfo,
            createOrder,
            invoice,
            payJump,
            info
        } = initPay(
            setActiveStep,
            subscriptionType,
            props.userType,
            props.projectId,
            props.isBatch
        );

        return {
            activeStep,
            setType,
            subscriptionType,
            setInfo,
            backStep,
            createOrder,
            invoice,
            payJump,
            info
        };
    }
});
